import gql from 'graphql-tag';

export const updateTag = gql`
  mutation updateTag($tag: UpdateTagInput!) {
    updateTag(tag: $tag) {
      id
    }
  }
`;
